var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 13.25C-2.93554e-08 13.6642 0.335787 14 0.75 14C1.16421 14 1.5 13.6642 1.5 13.25L1.5 0.750001C1.5 0.335788 1.16421 9.6915e-07 0.749998 1.00536e-06C0.335785 1.04157e-06 -2.14824e-06 0.335788 -2.11203e-06 0.750001L-6.55671e-08 13.25ZM10.9697 13.5303C11.2626 13.8232 11.7374 13.8232 12.0303 13.5303C12.3232 13.2374 12.3232 12.7626 12.0303 12.4697L6.56066 7L12.0303 1.53033C12.3232 1.23744 12.3232 0.762563 12.0303 0.46967C11.7374 0.176777 11.2626 0.176777 10.9697 0.46967L4.96967 6.46967C4.67678 6.76256 4.67678 7.23744 4.96967 7.53033L10.9697 13.5303Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationStart);
export default __webpack_public_path__ + "static/media/PaginationStart.7b7ad06ac48b825a5080fc2b2f1b620a.svg";
export { ForwardRef as ReactComponent };